import { IController } from 'angular';
import * as _ from 'lodash';

import { IRegentsExam, RegentsExam } from '../../../../../../../../ng2/shared/constants/regents.constant';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

interface IPastDueExamsByExam {
  [key: string]: {
    _ids: string[];
    studentIds: string[];
  };
}

interface IPatch {
  _ids: string[];
  path: string;
  newValue: string;
}

export class PlanPastDueExamsTransferCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public filteredStudents;
  public pastDueStudentExamsByExamName: IPastDueExamsByExam;
  public totalPastDueExams: number;
  public patches: IPatch[];
  public languageHelper;
  public options: IWizardFilterActionsOptions;

  constructor(private $scope, private WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.pastDueStudentExamsByExamName = this.getStudentsPastExamsByExamName();
    this.totalPastDueExams = this.WizardUtils.getCountOfStudentsToBePatched(this.pastDueStudentExamsByExamName);
    this.patches = this.WizardUtils.getRegentsExamBulkPatch(this.pastDueStudentExamsByExamName, 'shortName');
    this.languageHelper = this.WizardUtils.getRegentsWizardLanguageHelper('key');
    this.options = {
      columnKeys: ['cohort', 'pastDueRegentsExams', 'regentsSchedForNextAdmin'],
    };
  }

  private getStudentsPastExamsByExamName(): IPastDueExamsByExam {
    // generate baseObj
    const baseObj = _.reduce(
      RegentsExam,
      (result: any, { shortName }: IRegentsExam) => {
        result[shortName] = { _ids: [], studentIds: [] };
        return result;
      },
      {},
    );
    // populate
    return _.reduce(
      this.filteredStudents,
      (pastDueExamsByExamName, { _id, studentId, pastDueUnplannedRegentsExams }) => {
        _.each(pastDueUnplannedRegentsExams, examShortName => {
          baseObj[examShortName]._ids.push(_id);
          baseObj[examShortName].studentIds.push(studentId);
        });
        return baseObj;
      },
      baseObj,
    );
  }
}
